import { ImageOrientation } from '../constants/image-orientation'
import { MediaUploadPhotoDto, MediaUploadPhotoModel } from '../types/media-upload'

export const transformMediaUploadPhotoDto = (
  photoDto: MediaUploadPhotoDto,
): MediaUploadPhotoModel => ({
  id: photoDto.id,
  url: photoDto.url,
  tempUuid: photoDto.temp_uuid,
  highResolution: photoDto.high_resolution,
  fullSizeUrl: photoDto.full_size_url,
  isWeb: photoDto.extra.is_web,
  thumbnails: photoDto.thumbnails,
})

export const transformMediaUploadPhotoDtos = (
  photoDtos: Array<MediaUploadPhotoDto>,
): Array<MediaUploadPhotoModel> => photoDtos.map(transformMediaUploadPhotoDto)

export const transformMediaUploadPhotoDtosToOrientations = (
  photoDtos: Array<MediaUploadPhotoDto>,
) =>
  photoDtos.map(photoDto => ({
    id: photoDto.id,
    orientation: photoDto.orientation || ImageOrientation.Degree0,
  }))
